import React, { createContext, useContext } from "react";
import { Empty, List } from "antd";
import { Observer, observer } from "mobx-react-lite";
import renderHTML from "react-render-html";
import MonthlyPerformanceStore from "./store/monthlyperformancestore";
import { toJS } from "mobx";

import { MessageBar, MessageBarType } from "@fluentui/react";
const MonthlyPerformanceStoreCtx = createContext(MonthlyPerformanceStore);
export const ErrorLogs = observer(() => {
  const monthlyPerformanceStore = useContext(MonthlyPerformanceStoreCtx);
  return (
    <Observer>
      {() => (
        <List
          itemLayout="horizontal"
          locale={{
            emptyText: (
              <Empty description={`No upload errors,everything looks great.`} />
            ),
          }}
          dataSource={monthlyPerformanceStore.uploadErrors.map((x) => toJS(x))}
          renderItem={(item) => (
            <List.Item>
              <List.Item.Meta
                description={
                  <MessageBar
                    messageBarType={
                      item.type === "Error"
                        ? MessageBarType.error
                        : MessageBarType.warning
                    }
                  >
                    {renderHTML(item.message)}
                  </MessageBar>
                }
              />
            </List.Item>
          )}
        />
      )}
    </Observer>
  );
});

